import { useQuery } from "@apollo/client";
import { getOrgDetails } from "../graphql/queries";
import { OrgInfo, UseOrgDetailsResult } from "../types";

export function useOrgDetails(orgId: string | undefined, productId?: string): UseOrgDetailsResult {
    const { data, loading, error, refetch } = useQuery(getOrgDetails, {
        fetchPolicy: "network-only",
        variables: {
            filters: {
                orgId: orgId,
                ...(productId && { productId })
            }
        },
        skip: !orgId,
    });

    const orgInfo: OrgInfo | null = data?.traceOrgProductDetails?.orgDetails || null;
    const lotBatchLabel: string | undefined = data?.traceOrgProductDetails?.lotBatchLabel;
    const lotBatchLabelDesc: string | undefined = data?.traceOrgProductDetails?.lotBatchLabelDesc;

    return { orgInfo, loading, error, refetch, lotBatchLabel, lotBatchLabelDesc };
}
